import { logError } from '@log';
import {
  ApiPath,
  ApiUri,
  RequestMethod,
  RespCode,
} from '@constants';
import { request } from './request';

/**
 * 上传文件
 * @param {*} files 文件
 */
export const uploadFile = async (files) => {
  if (!files?.length) {
    return null;
  }
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    const resp = await request(ApiUri.Upload, {
      method: RequestMethod.Post,
      path: ApiPath.AgentApi,
      body: formData,
      /** 注：后台返回的 response header 的 Access-Control-Allow-Origin 是 *
       * 如果 credentials 是 'include'，fetch 请求会有跨域错误，
       * 这里设置成 same-origin，意思是只有同源的时候允许 cookie 传递
       * */
      credentials: 'same-origin',
    });
    const { code, data } = resp || {};
    if (code !== RespCode.Success) {
      logError(new Error(`uploadFile error, resp=${JSON.stringify(resp)}`));
      return null;
    }
    return data;
  } catch (error) {
    logError(error);
    return null;
  }
};
